module.exports = __webpack_public_path__ + "media/images/logo-outings-blue-61c7966e917e582c4a7a9f5ace5cb2f5.png";